'use strict';

var dealerFormsManager = function () {
  var currentVehicle = void 0;
  var _setCurrentVehicle = function _setCurrentVehicle(value) {
    return currentVehicle = value;
  },
      _getCurrentVehicle = function _getCurrentVehicle() {
    return currentVehicle;
  };

  var _init = function _init(vehicleData, area) {
    _setCurrentVehicle(vehicleData);
    // Banner Top
    vehicleApp.setCurrentArea(area);
    vehicleApp.setCurrentVehicle(vehicleData.vehicle);
    vehicleApp.setCurrentPrices(vehicleData.prices);
    vehicleApp.printTitle(vehicleData.vehicle.vdisplayModelo);
    vehicleApp.displayGeneralData();
    vehicleApp.displayImages();
    _printBreadCrum(vehicleData.vehicle);
    _printFinancial(vehicleData);
  };

  var _printBreadCrum = function _printBreadCrum(vehicle) {
    var modelPath = utils.getDisplayModelName(vehicle.vdisplayModelo).completeName.toLowerCase().replace(' ', '-');
    var modelName = utils.getDisplayModelName(vehicle.vdisplayModelo).completeName;
    var vehiclePath = vehicle.vcodcom17;
    var versionName = vehicle.vgrado;

    $('.js-prev').text(modelName).attr('href', '../../' + modelPath);
    $('.js-prev-2').text(modelName + ' ' + versionName).attr('href', '../' + vehiclePath);
    $('.js-page').text('Da el siguiente paso');
  };

  var _printFinancial = function _printFinancial(vehicleData) {
    if (sessionStorage.cafi) {
      var cafiData = JSON.parse(sessionStorage.cafi);
      if (cafiData[vehicleData.vehicle.vcodcom17]) {
        var financialObj = cafiData[vehicleData.vehicle.vcodcom17];
        $('.js-cafi-cuota').text(utils.formatPrice(financialObj.cuota_financiera, 1));
        $('.js-cafi-open').removeClass('hidden');
      }
    }
  };

  // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function _setSelection(codhost, dealername, cp) {
    _showTabs(codhost);

    $(selectors.dlrName).html('Tu concesionario escogido es <strong>' + dealername + '</strong>');
    var botonModificar = $('<button/>').text('Modificar').addClass('h-btn grey h-icon editpencil2').on('click', function (event) {
      event.preventDefault();
      _abreConces();
      dtmTag.track.toggle('switch form', 'Modificar');
    });
    $(selectors.dlrName).append(botonModificar);
    $(selectors.dlrsContainer).slideUp();
  }

  function _abreConces() {
    _resetForms();
    _hideForms();
    $(selectors.dlrName).text($(selectors.dlrName).attr('data-defecto'));
    $(selectors.dlrsContainer).slideDown('slow');
  }

  var _checkTpvDealer = function _checkTpvDealer(codhost) {
    var matchSelectedInList = dealersData.dealers.filter(function (dealer) {
      return dealer.codHost === codhost;
    });
    console.log('with TPV', matchSelectedInList);
    if (matchSelectedInList.length > 0) {
      if (matchSelectedInList[0].tpvDealer) {
        return true;
      }
    }
    return false;
  };

  var _resetForms = function _resetForms() {
    document.forms.formOffer.reset();
    document.forms.formSale.reset();
  };

  var _hideForms = function _hideForms() {
    $('.js-forms-container').addClass('inactive');
  };

  var _showTabs = function _showTabs(codhost) {
    _resetForms();
    var formOfferParams = {
      selector: '#formOffer',
      dealerType: 'general',
      dealerSelect: '.js-field-dealer',
      options: {
        rules: {
          dealer: {
            required: true,
            messages: {
              required: 'Campo obligatorio'
            }
          },
          surname1: {
            required: true,
            alphabetical: true,
            messages: {
              required: 'Campo obligatorio',
              alphabetical: 'Sólo caracteres alfabéticos'
            }
          },
          phone: {
            required: true,
            mobilePhoneES_AD: true,
            messages: {
              required: 'Campo obligatorio',
              mobilePhoneES_AD: 'Teléfono móvil no válido'
            }
          },
          postalcode: {
            required: true,
            cpES_AD: true,
            messages: {
              required: 'Campo obligatorio',
              cpES_AD: 'Código postal no válido'
            }
          }
        }
      }
    };
    var requiredTxt = 'Campo obligatorio';
    var formSaleParams = {
      selector: '#formSale',
      dealerType: 'general',
      dealerSelect: '.js-field-dealer',
      options: {
        rules: {
          dealer: {
            required: true,
            messages: {
              required: requiredTxt
            }
          },
          surname1: {
            required: true,
            alphabetical: true,
            messages: {
              required: requiredTxt,
              alphabetical: 'Sólo caracteres alfabéticos'
            }
          },
          surname2: {
            required: true,
            alphabetical: true,
            messages: {
              required: requiredTxt,
              alphabetical: 'Sólo caracteres alfabéticos'
            }
          },
          phone: {
            required: true,
            mobilePhoneES_AD: true,
            messages: {
              required: requiredTxt,
              mobilePhoneES_AD: 'Teléfono móvil no válido'
            }
          },
          nif: {
            required: true,
            nifNie: true,
            messages: {
              required: requiredTxt,
              nifNie: 'Formato N.I.F. no válido'
            }
          },
          postalcode: {
            required: true,
            cpES_AD: true,
            messages: {
              required: requiredTxt,
              cpES_AD: 'Código postal no válido'
            }
          },
          birthdate: {
            required: true,
            dateEsFormat: true,
            messages: {
              required: requiredTxt,
              dateEsFormat: 'El formato debe ser dd/mm/aaaa'
            }
          },
          citizenship: {
            required: true,
            messages: {
              required: requiredTxt
            }
          },
          address: {
            required: true,
            messages: {
              required: requiredTxt
            }
          }
        }
      }
    };

    if (_checkTpvDealer(codhost)) {
      $('.js-form-sale-elem').removeClass('hidden');
      $('.js-label-force').removeClass('force-border-left');
      $('#tab_one').prop('checked', true);
      $('#tab_two').prop('checked', false);
      formsApp.init(formSaleParams);
    } else {
      $('.js-form-sale-elem').addClass('hidden');
      $('.js-label-force').addClass('force-border-left');
      $('#tab_two').prop('checked', true);
    }
    $('*[name=pcodHost]').val(codhost);
    formsApp.init(formOfferParams);

    $('.js-forms-container').removeClass('inactive');
  };

  return {
    init: _init,
    setSelection: _setSelection
  };
}();